import React from 'react';
import { ArrowRight, Play } from 'lucide-react';

const Hero = ({ onEnquireClick }) => {
  const scrollToProperties = () => {
    const el = document.querySelector('#properties');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1514939775307-d44e7f10cabd?w=1920&h=1080&fit=crop"
          alt="Luxury Cityscape"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-block mb-6">
            <span className="px-4 py-2 text-xs font-semibold tracking-[0.2em] text-[#DAA520] border border-[#DAA520]/40 rounded-sm bg-[#DAA520]/5">
              LUXURY REAL ESTATE
            </span>
          </div>

          {/* Heading */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight mb-6">
            <span className="text-white">Discover your </span>
            <span className="text-[#DAA520] italic">dream property</span>
            <br />
            <span className="text-white">with </span>
            <span className="text-[#DAA520] italic">us</span>
          </h1>

          {/* Subtitle */}
          <p className="text-gray-400 text-lg sm:text-xl leading-relaxed mb-10 max-w-lg">
            Experience unparalleled luxury with our exclusive collection of premium properties.
            Where exceptional living meets extraordinary design.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={onEnquireClick}
              className="group flex items-center justify-center gap-2 px-8 py-4 bg-[#DAA520] text-black font-semibold tracking-wider text-sm rounded-sm hover:bg-[#C49B17] transition-all duration-300"
            >
              SCHEDULE A VIEWING
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={scrollToProperties}
              className="group flex items-center justify-center gap-2 px-8 py-4 border border-white/30 text-white font-semibold tracking-wider text-sm rounded-sm hover:border-white/60 hover:bg-white/5 transition-all duration-300"
            >
              <Play size={16} className="fill-white" />
              EXPLORE PROPERTIES
            </button>
          </div>
        </div>
      </div>

      {/* Decorative scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-[#DAA520] rounded-full mt-2 animate-bounce" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
